import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13500228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1))

import { H3, Button } from "../atoms"
import { ref } from "vue"
interface Props {
	company: string
	informations: string[]
}

/* eslint-disable no-undef */

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyModalSimple',
  props: {
    company: null,
    informations: null
  },
  setup(__props: any) {

const props = __props as {
	company: string
	informations: string[]
};

const dialog = ref(false)


/* eslint-enable no-undef */

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Button), {
      background: "#fff",
      color: "#09092A",
      bd: "#CFD1E1",
      class: "font",
      w: "11rem"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Informações do tomador ")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
      activator: "parent",
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(props.company), 1)
                ]),
                _hoisted_3,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.informations, (info) => {
                    return (_openBlock(), _createElementBlock("li", { key: info }, _toDisplayString(info), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  block: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Fechar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})